import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  { path: '/', name: 'home', component: () => import('../views/Home.vue') },
  { path: '/about', name: 'about', component: () => import('../views/About.vue') },
  { path: '/solutions', name: 'solutions', component: () => import('../views/Solutions.vue') },
  { path: '/solutions/:id', name: 'solution-detail', component: () => import('../views/SolutionsDetail.vue') },
  { path: '/products', name: 'products', component: () => import('../views/Products.vue') },
  { path: '/products/:id', name: 'product-detail', component: () => import('../views/CommonDetail.vue') },
  { path: '/projects', name: 'projects', component: () => import('../views/Projects.vue') },
  { path: '/projects/:id', name: 'project-detail', component: () => import('../views/CommonDetail.vue') },
  { path: '/news', name: 'news', component: () => import('../views/News.vue') },
  { path: '/news/:id', name: 'news-detail', component: () => import('../views/CommonDetail.vue') },
  { path: '/w-admin', name: 'admin', component: () => import('../views/Admin.vue') },
]

export default routes